/**
 * コレクションページの無限スクロール。
 * ページ送りの代わりに、スクロールで次ページを読み込んで商品グリッドに追加する。
 * （ボタンも残すので、自動読み込みが働かない環境でも手動で読み込める）
 */
class InfiniteScroll {
  constructor(container) {
    this.container = container;
    this.button = container.querySelector('.infinite-scroll__button');
    this.spinner = container.querySelector('.infinite-scroll__spinner');
    this.loading = false;

    this.button?.addEventListener('click', () => this.loadNext());

    // ビューポートに近づいたら自動で読み込む
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) this.loadNext();
      },
      { rootMargin: '600px 0px' }
    );
    this.observer.observe(container);
  }

  get grid() {
    return document.getElementById('product-grid');
  }

  async loadNext() {
    const url = this.container.dataset.nextUrl;
    if (this.loading || !url) return;

    this.loading = true;
    this.setBusy(true);

    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

      const newGrid = doc.getElementById('product-grid');
      const grid = this.grid;
      if (newGrid && grid) {
        grid.append(...newGrid.children);
      }

      // 次ページのURLを引き継ぐ（無ければ読み込み終了）
      const nextContainer = doc.querySelector('[data-infinite-scroll]');
      const nextUrl = nextContainer?.dataset.nextUrl;
      if (nextUrl) {
        this.container.dataset.nextUrl = nextUrl;
      } else {
        this.finish();
      }
    } catch (e) {
      console.error('無限スクロールの読み込みに失敗しました', e);
      // 失敗時はボタンを残して手動リトライできるようにする
    } finally {
      this.loading = false;
      this.setBusy(false);
    }
  }

  setBusy(busy) {
    if (!this.button) return;
    this.button.classList.toggle('hidden', busy);
    this.spinner?.classList.toggle('hidden', !busy);
  }

  finish() {
    this.observer.disconnect();
    this.container.remove();
  }
}

function initInfiniteScroll() {
  document.querySelectorAll('[data-infinite-scroll]').forEach((el) => {
    if (!el.dataset.initialized) {
      el.dataset.initialized = 'true';
      new InfiniteScroll(el);
    }
  });
}

initInfiniteScroll();
document.addEventListener('DOMContentLoaded', initInfiniteScroll);
document.addEventListener('shopify:section:load', initInfiniteScroll);

// 絞り込み（フィルター）でグリッドが差し替わったときにも再初期化する
const gridContainer = document.getElementById('ProductGridContainer');
if (gridContainer) {
  new MutationObserver(initInfiniteScroll).observe(gridContainer, {
    childList: true,
    subtree: true,
  });
}
